var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper-wrapper text-center"},[(_vm.stepper.steps.length)?_c('ul',_vm._l((_vm.stepper.steps),function(step,index){return _c('li',{key:index,staticClass:"step",class:[_vm.isCurrentStep(index), step.status ? step.status : '']},[_c('div',{staticClass:"step-circle"})])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }